import axios from "axios";
import { useCallback } from "react";

export function useCreateProductServicePublicAxiosInstance() {
  const createAxiosInstance = useCallback(() => {
    return axios.create({
      baseURL: import.meta.env.VITE_PRODUCT_SERVICE_BASE_URL,
    });
  }, []);

  return {
    createAxiosInstance,
  };
}
